import styled from 'styled-components';

// Styles the form
export default styled.legend`
  border-bottom: ${({ theme }) => theme.borders.default}
  margin-bottom: 1.4285em;
  width: 100%;
  margin-bottom: 15px;
`;
